<template>
  <form-item-wrapper v-bind="bind"> {{ formatName }} </form-item-wrapper>
</template>
<script>
import { staticMixins, mapVFAssignField } from "@/CommonDP/VForm/utils";
import projectService from "@/CommonDP/service/project-service";
const prjMap = {};
export default {
  mixins: [staticMixins],
  inheritAttrs: false,
  data() {
    return {
      curPrjInfo: {}
    };
  },

  computed: {
    ...mapVFAssignField({ prjName: "mapPrjNameTo", prjCode: "mapPrjCodeTo" }),
    formatName() {
      const {
        curPrjInfo: { prjName, prjCode }
      } = this;
      return prjName ? `${prjCode} - ${prjName}` : "--";
    },
    vmDefaultValue() {
      return this.prjId;
    }
  },
  watch: {
    prjId: {
      immediate: true,
      handler: "handlePrjIdChanged"
    }
  },
  methods: {
    async handlePrjIdChanged(prjId) {
      this.preventDesign();
      await this.$nextTick();
      if (prjId) {
        const req = prjMap[prjId] || projectService.tryGetProjectDetail({ prjId });
        prjMap[prjId] = req;
        const { data } = await req;
        this.curPrjInfo = data || {};
        if (prjId !== data.prjId) return;
        this.prjName = data.prjName;
        this.prjCode = data.prjCode;
      }
    }
  }
};
</script>
